import React from 'react';

const Footer = ({ layoutContext: { content } }) => (
  <div className="footer">
    <div className="content">
      <div className="flex-container">
        <div className="block-one">
          <div className="company">{content.company}</div>
          <div className="number">{content.footer.number}</div>
          <div className="address">{content.address}</div>
        </div>
        <div className="block-two">
          {content.footer.phone.title}
          <div className="phone-numbers">
            {content.phones.map(phone => <div key={`key_${phone}`}>{phone}</div>)}
          </div>
        </div>
      </div>
    </div>
    <div className="content copyright">
      © {content.company}, {new Date().getFullYear()}. Visas tiesības aizsargātas.
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx